/* Signora global reveal observer. Styling lives in sjw-global-ui.css. */
(function () {
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    var elements = document.querySelectorAll('.sjw-reveal:not(.in)');
    for (var index = 0; index < elements.length; index += 1) elements[index].classList.add('in');
  }

  function init() {
    if (reducedMotion || document.documentElement.dataset.sjwMotion !== 'on' || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var index = 0; index < entries.length; index += 1) {
        if (entries[index].isIntersecting) {
          entries[index].target.classList.add('in');
          observer.unobserve(entries[index].target);
        }
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    var elements = document.querySelectorAll('.sjw-reveal:not(.in)');
    for (var item = 0; item < elements.length; item += 1) observer.observe(elements[item]);
    window.setTimeout(revealAll, 4000);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  window.addEventListener('load', revealAll);
  document.addEventListener('shopify:section:load', init);
})();

/* Immediate, non-blocking feedback while Shopify's hosted account flow opens. */
(function () {
  'use strict';

  var authSelector = '.header__icon--account, .header-mobile__login-link, .header-mobile__signup-link';
  var loadingClass = 'is-sjw-auth-loading';
  var status;

  function ensureStatus() {
    if (status && status.isConnected) return status;

    status = document.createElement('span');
    status.className = 'visually-hidden sjw-auth-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    (document.body || document.documentElement).appendChild(status);

    return status;
  }

  function resetAuthFeedback() {
    var links = document.querySelectorAll(authSelector + '.' + loadingClass);

    for (var index = 0; index < links.length; index += 1) {
      links[index].classList.remove(loadingClass);
      links[index].removeAttribute('aria-busy');

      var spinner = links[index].querySelector('.sjw-auth-spinner');
      if (spinner) spinner.remove();
    }

    if (status) status.textContent = '';
  }

  function showAuthFeedback(event) {
    if (
      event.defaultPrevented ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      (event.button !== undefined && event.button !== 0)
    ) return;

    var target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
    var link = target && target.closest ? target.closest(authSelector) : null;

    if (
      !link ||
      link.classList.contains(loadingClass) ||
      link.hasAttribute('download') ||
      (link.target && link.target !== '_self')
    ) return;

    link.classList.add(loadingClass);
    link.setAttribute('aria-busy', 'true');

    var spinner = document.createElement('span');
    spinner.className = 'sjw-auth-spinner';
    spinner.setAttribute('aria-hidden', 'true');
    link.appendChild(spinner);

    var label = link.getAttribute('aria-label') || (link.textContent || '').trim();
    ensureStatus().textContent = label ? label + '\u2026' : '\u2026';
  }

  document.addEventListener('click', showAuthFeedback, true);
  window.addEventListener('pageshow', resetAuthFeedback);
})();
